import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// Stock Pulse. Three questions off one dataset: what is being ordered against
// what is being used, whether one engineer's order reconciles with his job
// cards, and what a van cannot account for between two counts.

const clean = (params) => Object.fromEntries(
  Object.entries(params || {}).filter(([, v]) => v !== null && v !== undefined && v !== ''));

export function usePulseFilters() {
  return useQuery({
    queryKey: ['stock-pulse', 'filters'],
    queryFn: async () => (await api.get('/api/stock-pulse/filters')).data,
    staleTime: 5 * 60 * 1000,   // vans and engineers barely move
    retry: false,
  });
}

export function usePulseOverview(params) {
  const q = clean(params);
  return useQuery({
    queryKey: ['stock-pulse', 'overview', q],
    queryFn: async () => (await api.get('/api/stock-pulse', { params: q })).data,
    // The underlying tables change as engineers submit, and this page exists to
    // be believed, so nothing is served from cache without a refetch.
    staleTime: 0,
    retry: false,
  });
}

export function useEngineerPulse(entraId, params) {
  const q = clean(params);
  return useQuery({
    queryKey: ['stock-pulse', 'engineer', entraId, q],
    queryFn: async () => (await api.get(`/api/stock-pulse/engineer/${entraId}`, { params: q })).data,
    enabled: !!entraId,
    staleTime: 0,
    retry: false,
  });
}

export function useVanPulse(reg, params) {
  const q = clean(params);
  return useQuery({
    queryKey: ['stock-pulse', 'van', reg, q],
    queryFn: async () => (await api.get(`/api/stock-pulse/van/${encodeURIComponent(reg)}`, { params: q })).data,
    enabled: !!reg,
    staleTime: 0,
    retry: false,
  });
}
